module.exports = __webpack_public_path__ + "9b49ccafd438a4aa90ebb06698ea2eae.png";